import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container-full-5" }
const _hoisted_2 = { class: "pin-card" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = {
  key: 0,
  class: "alert alert-error"
}
const _hoisted_7 = {
  key: 1,
  class: "alert alert-success"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("h1", { class: "secondary-font gap-4 mt-2 mb-2" }, " Modifier mon PIN ", -1)),
    _cache[9] || (_cache[9] = _createElementVNode("p", { class: "mb-5 text-grey-600" }, " Changez votre code PIN pour sécuriser votre compte. ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleChangePin && _ctx.handleChangePin(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _cache[4] || (_cache[4] = _createElementVNode("label", { for: "current-pin" }, "PIN actuel", -1)),
          _withDirectives(_createElementVNode("input", {
            id: "current-pin",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPin) = $event)),
            type: "password",
            maxlength: "4",
            class: "form-input",
            placeholder: "••••",
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.currentPin]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("label", { for: "new-pin" }, "Nouveau PIN", -1)),
          _withDirectives(_createElementVNode("input", {
            id: "new-pin",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newPin) = $event)),
            type: "password",
            maxlength: "4",
            class: "form-input",
            placeholder: "••••",
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.newPin]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[6] || (_cache[6] = _createElementVNode("label", { for: "confirm-pin" }, "Confirmer le nouveau PIN", -1)),
          _withDirectives(_createElementVNode("input", {
            id: "confirm-pin",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confirmPin) = $event)),
            type: "password",
            maxlength: "4",
            class: "form-input",
            placeholder: "••••",
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.confirmPin]
          ])
        ]),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.error), 1))
          : _createCommentVNode("", true),
        (_ctx.success)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.success), 1))
          : _createCommentVNode("", true),
        _cache[7] || (_cache[7] = _createElementVNode("button", {
          type: "submit",
          class: "btn flex-center gap-2 mt-4"
        }, [
          _createElementVNode("img", {
            src: "/public/icons/icon-menu-securite.svg",
            alt: "",
            class: "btn-icon btn-icon-white"
          }),
          _createTextVNode(" Modifier mon PIN ")
        ], -1))
      ], 32)
    ])
  ]))
}